import { useFindDocumentsSuspense } from "@api";
import type { IDocument } from "@bbj-types/document";
import type { DocumentTypes } from "@bbj-types/document/enum";
import type { ObjectId } from "@bbj-types/utils";
import { DialogContent } from "@mui/material";
import type { CreateAction } from "@root/utils/enums/communication";
import type { Dispatch, SetStateAction } from "react";
import { SendMailModalMailContentBody } from "./mailContent/body";
import { SendMailModalRecipientsBody } from "./recipients/body";
import { SendMailModalStepper, SendMailStep } from "./stepper";
import type { IRecipient } from "./type";

interface ISendMailModalContentProps {
  step: SendMailStep;
  recipients: IRecipient[];
  setRecipients: Dispatch<SetStateAction<IRecipient[]>>;
  coachingStepChange: string | undefined;
  setCoachingStepChange: Dispatch<SetStateAction<string | undefined>>;
  createAction: CreateAction;
  setCreateAction: Dispatch<SetStateAction<CreateAction>>;
  template: IDocument | null;
  setTemplate: Dispatch<SetStateAction<IDocument | null>>;
  templatePreviewLoading: boolean;
  setTemplatePreviewLoading: Dispatch<SetStateAction<boolean>>;
  getMailPreview: (templateId: ObjectId) => Promise<string | undefined>;
  templateTypeDoc: DocumentTypes.WORKSHOP_MAIL_TEMPLATE;
  invalidRecipientsCount: number;
}

export const SendMailModalContent = ({
  step,
  recipients,
  setRecipients,
  coachingStepChange,
  setCoachingStepChange,
  createAction,
  setCreateAction,
  template,
  setTemplate,
  templatePreviewLoading,
  setTemplatePreviewLoading,
  getMailPreview,
  templateTypeDoc,
  invalidRecipientsCount,
}: ISendMailModalContentProps) => {
  const getMailTemplates = useFindDocumentsSuspense(undefined, undefined, [templateTypeDoc]);

  return (
    <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 3, height: "630px" }}>
      <SendMailModalStepper step={step} />
      {step === SendMailStep.RECIPIENTS ? (
        <SendMailModalRecipientsBody
          recipients={recipients}
          setRecipients={setRecipients}
          coachingStepChange={coachingStepChange}
          setCoachingStepChange={setCoachingStepChange}
          createAction={createAction}
          setCreateAction={setCreateAction}
          invalidRecipientsCount={invalidRecipientsCount}
        />
      ) : (
        <SendMailModalMailContentBody
          template={template}
          setTemplate={setTemplate}
          templatePreviewLoading={templatePreviewLoading}
          setTemplatePreviewLoading={setTemplatePreviewLoading}
          getMailPreview={getMailPreview}
          getMailTemplates={getMailTemplates}
        />
      )}
    </DialogContent>
  );
};
